import { Img } from "../Img/index";

const RecognitionActionCard = ({ element, handleOpenDrawer, onDelete, isError }:any) => {
  return (
    <div
      className={`bg-white rounded-lg shadow-lg ${isError ? "shadow-red-500" : ""} overflow-hidden flex flex-col h-full w-full`}
      style={{ fontFamily: "'Manrope', sans-serif" }}
    >
      {/* Top image section with 16:9 aspect ratio */}
      <div className="relative w-full">
        {element?.RECOGNITION_IMAGE?.selectedImage ? (
          <div className="relative w-full pt-[56.25%]">
            <Img
              src={element?.RECOGNITION_IMAGE?.selectedImage}
              alt="Recognition"
              className="absolute top-0 left-0 w-full h-full object-cover"
            />
            {/* Gradient overlay covers entire container */}
            <div
              className="absolute top-0 left-0 w-full h-full pointer-events-none z-10"
              style={{
                background: "linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 40%)",
              }}
            ></div>
            {/* Action buttons with white icons (via inversion), above the gradient */}
            <div className="absolute top-2 right-2 flex space-x-2 z-20">
              {!!handleOpenDrawer && <button
                onClick={handleOpenDrawer}
                className="bg-black/60 rounded-full p-1.5 hover:bg-black/80"
                type="button"
              >
                <img
                  src="/images/edit-3.svg"
                  alt="edit"
                  className="w-[2.7vh] h-[2.7vh] filter invert"
                />
              </button>}
             {!!onDelete && <button
                onClick={onDelete}
                className="bg-black/60 rounded-full p-1.5 hover:bg-black/80"
                type="button"
              >
                <img
                  src="/images/trash.svg"
                  alt="delete"
                  className="w-[2.7vh] h-[2.7vh] filter invert"
                />
              </button>}
            </div>
          </div>
        ) : (
          <div className="relative w-full pt-[56.25%] bg-gray-200">
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-gray-500 font-medium text-[2vh]">
                {element.RECOGNITION_ACHIEVEMENT ? element.RECOGNITION_ACHIEVEMENT.charAt(0) : ""}
              </span>
            </div>
            {/* Gradient overlay for placeholder */}
            <div
              className="absolute top-0 left-0 w-full h-full pointer-events-none z-10"
              style={{
                background: "linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 40%)",
              }}
            ></div>
            {/* Action buttons for placeholder */}
            <div className="absolute top-2 right-2 flex space-x-2 z-20">
              <button
                onClick={handleOpenDrawer}
                className="bg-black/60 rounded-full p-1.5 hover:bg-black/80"
                type="button"
              >
                <img
                  src="/images/edit-3.svg"
                  alt="edit"
                  className="w-[2.7vh] h-[2.7vh] filter invert"
                />
              </button>
              <button
                onClick={onDelete}
                className="bg-black/60 rounded-full p-1.5 hover:bg-black/80"
                type="button"
              >
                <img
                  src="/images/trash.svg"
                  alt="delete"
                  className="w-[2.7vh] h-[2.7vh] filter invert"
                />
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Content section for award details */}
      <div className="p-3 flex flex-col flex-grow">
        <h3 className="font-medium text-gray-900 text-[2vh] line-clamp-2 mb-1">
          {element.RECOGNITION_ACHIEVEMENT || "Achievement"}
        </h3>
        <h3 className="font-medium text-gray-500 text-[2vh] line-clamp-2 mb-1">
          {element.RECOGNITION_ISSUED_BY || "Achievement issued by"}
        </h3>
        <p className="text-[1.8vh] text-gray-500 mb-1">
          {element.RECOGNITION_YEAR || "Date"}
        </p>
      </div>
    </div>
  );
};

export default RecognitionActionCard;